/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Body_Assessment_Capture_FrontInputs */

const en_us2_body_assessment_capture_front = /** @type {(inputs: Body_Assessment_Capture_FrontInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Front`)
};

const pt_br2_body_assessment_capture_front = /** @type {(inputs: Body_Assessment_Capture_FrontInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Frente`)
};

const es_419_body_assessment_capture_front = /** @type {(inputs: Body_Assessment_Capture_FrontInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Frente`)
};

const pt_pt2_body_assessment_capture_front = /** @type {(inputs: Body_Assessment_Capture_FrontInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Frente`)
};

const fr_fr2_body_assessment_capture_front = /** @type {(inputs: Body_Assessment_Capture_FrontInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Face`)
};

const de_de2_body_assessment_capture_front = /** @type {(inputs: Body_Assessment_Capture_FrontInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vorne`)
};

const it_it2_body_assessment_capture_front = /** @type {(inputs: Body_Assessment_Capture_FrontInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fronte`)
};

/**
* | output |
* | --- |
* | "Front" |
*
* @param {Body_Assessment_Capture_FrontInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_assessment_capture_front = /** @type {((inputs?: Body_Assessment_Capture_FrontInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Assessment_Capture_FrontInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_assessment_capture_front(inputs)
	if (locale === "es-419") return es_419_body_assessment_capture_front(inputs)
	if (locale === "pt-PT") return pt_pt2_body_assessment_capture_front(inputs)
	if (locale === "fr-FR") return fr_fr2_body_assessment_capture_front(inputs)
	if (locale === "de-DE") return de_de2_body_assessment_capture_front(inputs)
	if (locale === "it-IT") return it_it2_body_assessment_capture_front(inputs)
	return en_us2_body_assessment_capture_front(inputs)
});
export { body_assessment_capture_front as "body-assessment.capture_front" }